import React, { useEffect } from 'react';
import i18n from '@/i18n';

interface LocaleLayoutProps {
  lang: string;
  children: React.ReactNode;
}

/**
 * Wraps every marketing/legal route (English included) so navigating between
 * locales client-side keeps i18next in sync with the URL. The initial render
 * already matches (src/i18n/index.ts detects the locale from the URL
 * synchronously at startup) - this effect only matters for subsequent SPA
 * navigations that don't trigger a full page load. <html lang> itself is
 * owned by the SEO component (via Helmet), which every wrapped page renders.
 */
const LocaleLayout: React.FC<LocaleLayoutProps> = ({ lang, children }) => {
  useEffect(() => {
    if (i18n.language !== lang) {
      i18n.changeLanguage(lang);
    }
  }, [lang]);

  return <>{children}</>;
};

export default LocaleLayout;
